import template from '../sprint-popup.html';
import controller from './sprint-editor-popup.controller';

const SprintEditorPopupComponent = {
  template,
  controller,
  bindings: {
      readOnly: '<'
  },
};

export default SprintEditorPopupComponent;



// WEBPACK FOOTER //
// ./components/popups/sprint/editor/sprint-editor-popup.component.js